const copy = {
  fr: { title: 'Votre besoin a été partagé', body: (company, need) => `${company} a partagé votre besoin « ${need} ».` },
  de: { title: 'Ihr Gesuch wurde geteilt', body: (company, need) => `${company} hat Ihr Gesuch „${need}“ geteilt.` },
  it: { title: 'La tua richiesta è stata condivisa', body: (company, need) => `${company} ha condiviso la tua richiesta «${need}».` },
  en: { title: 'Your request was shared', body: (company, need) => `${company} shared your request “${need}”.` },
}

export function needShareNotificationText(notification, lang = 'fr') {
  const selected = copy[lang] || copy.fr
  const company = String(notification?.shared_by_company_name || 'Hubbing').trim()
  const need = String(notification?.shared_need_title || '').trim()
  return { title: selected.title, body: need ? selected.body(company, need) : company }
}
